import React from "react";
import FeaturePageLayout from "./FeaturePageLayout";

const cards = [
  {
    bg: "#EFF6FF",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
    title: "Campanhas em Massa",
    desc: "Envie mensagens personalizadas para listas segmentadas com rastreamento de entrega em tempo real.",
  },
  {
    bg: "#fce7f3",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0EA5E9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M6 20v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/></svg>,
    title: "Segmentação de Contatos",
    desc: "Filtre e agrupe clientes por tags, histórico de compras, canal de origem e dezenas de critérios.",
  },
  {
    bg: "#E6F7FF",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#14B8A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>,
    title: "Texto com IA",
    desc: "A IA gera uma mensagem única para cada contato com base no perfil, histórico e objetivo da campanha.",
  },
  {
    bg: "#dbeafe",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>,
    title: "Relatórios de Campanha",
    desc: "Acompanhe taxa de entrega, leitura, cliques e respostas em um dashboard visual e completo.",
  },
  {
    bg: "#fef3c7",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>,
    title: "Agendamento de Disparos",
    desc: "Programe campanhas para horários de maior engajamento e evite sobrecarga nos canais.",
  },
  {
    bg: "#ffedd5",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ea580c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 17l6-6-6-6"/><path d="M12 19h8"/></svg>,
    title: "Webhooks & Integrações",
    desc: "Conecte sua campanha ao CRM, e-commerce ou qualquer sistema via webhook para automatizar fluxos completos.",
  },
];

const steps = [
  { title: "Importe ou segmente sua lista", desc: "Carregue contatos via CSV ou use filtros para criar segmentos dinâmicos diretamente na plataforma." },
  { title: "Crie a mensagem com IA", desc: "Escreva um roteiro ou deixe a IA gerar textos personalizados para cada perfil de contato automaticamente." },
  { title: "Agende e dispare", desc: "Defina data, hora e velocidade do disparo. A plataforma gerencia as filas e evita bloqueios." },
  { title: "Analise os resultados", desc: "Veja em tempo real quem recebeu, leu e respondeu. Ajuste e reutilize sua campanha com dados reais." },
];

const visual = {
  icon: (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  label: "Campanhas com IA",
  sub: "Dispare mensagens que convertem",
};

const FeatureMarketing = () => (
  <FeaturePageLayout
    tag="Marketing & Campanhas"
    title="Campanhas que"
    titleHi="realmente convertem"
    sub="Dispare mensagens personalizadas via WhatsApp para milhares de contatos com textos gerados por IA e relatórios em tempo real."
    cards={cards}
    steps={steps}
    visual={visual}
  />
);

export default FeatureMarketing;
